import React from 'react';
import styled from '@emotion/styled';
import { AiOutlineRadiusUpright } from '@react-icons/all-files/ai/AiOutlineRadiusUpright';
import { MdLineWeight } from '@react-icons/all-files/md/MdLineWeight';
import { NumberInputField } from '@bucketplace/commerce-admin-ui';

import { ColorPickerField, FormContent } from '@/components';

import { GutterField } from './GutterField';

export function BoxModelForm() {
  return (
    <>
      <GutterField name="margin" label="마진" />
      <GutterField name="padding" label="패딩" />
      <FormContent header="테두리" direction="VERTICAL">
        <GapWrapper>
          <ColorPickerField
            name="border.color"
            width="100%"
          />
          <NumberInputField
            name="border.width"
            width="100%"
            label={<MdLineWeight />}
            direction="HORIZONTAL"
          />
          <NumberInputField
            name="border.radius"
            width="100%"
            label={<AiOutlineRadiusUpright />}
            direction="HORIZONTAL"
          />
        </GapWrapper>
      </FormContent>
    </>
  );
}

const GapWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
`;
